import Constant from '../common/Constant';

const moment = require('moment');

function msToTime(duration) {
  let seconds = parseInt((duration / 1000) % 60, 10);
  let minutes = parseInt((duration / (1000 * 60)) % 60, 10);
  const hours = parseInt((duration / (1000 * 60 * 60)) % 24, 10);

  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}`;
}

export function getTimerText(timer) {
  const { status, startAtMillis, millisRecorded } = timer;
  let millis = 0;
  if (status === Constant.TIMER_NOT_RUNNING) {
    return '0:00:00';
  } else if (status === Constant.TIMER_RUNNING) {
    millis += millisRecorded + (moment().valueOf() - startAtMillis);
  } else if (status === Constant.TIMER_PAUSED) {
    millis += millisRecorded;
  }
  return msToTime(millis);
}



// WEBPACK FOOTER //
// ./src/helpers/timer.js